import { render } from "./ProfileLanding.vue?vue&type=template&id=39a6f54c&scoped=true"
import script from "./ProfileLanding.vue?vue&type=script&lang=js"
export * from "./ProfileLanding.vue?vue&type=script&lang=js"

import "./ProfileLanding.vue?vue&type=style&index=0&id=39a6f54c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a6f54c"]])

export default __exports__